import { Field, Form, Formik } from "formik";
import { useState } from "react";
import { useIntl } from "react-intl";
import {
  CheckIsNull,
  ResolveArrayNull,
} from "../../../../../utils/CommonHelper";
import { Input } from "../../../../common/components/control/InputField";
import { PromotionItem } from "../../../../common/components/PromotionItem";
import { transferSchema } from "../../yupSchema/transferSchema";
import { PromotionListDialog } from "./PromotionListDialog";

export const TransferForm = ({
  formikRef,
  saveValues,
  gameBalance,
  mainWallet,
  isDeposit,
  rate,
  promoLock,
  promotionListsV2,
  promotionId,
  defaultPromoId,
}) => {
  const intl = useIntl();
  const [show, setShow] = useState(false);

  const getSelectedPromo = (promotionid) =>
    promotionListsV2?.find((promo) => promo?.promotionid === promotionid);

  const getLastSelectedPromo = () =>
    promotionListsV2?.find((promo) => promo?.selected === "true");

  return (
    <Formik
      initialValues={{
        amount: "",
        promotionid: defaultPromoId,
      }}
      innerRef={formikRef}
      validationSchema={transferSchema(intl)}
      enableReinitialize={true}
      onSubmit={(values, formikHelpers) => {
        const queryParams = {
          amount: values.amount,
          promotionid: values.promotionid,
        };

        saveValues(queryParams);
      }}
    >
      {({
        values,
        handleSubmit,
        setFieldValue,
        touched,
        errors,
        setFieldError,
      }) => (
        <Form>
          <PromotionListDialog
            setShow={(isShow) => {
              if (document.activeElement && document.activeElement.blur) {
                document.activeElement.blur();
              }
              setShow(isShow);
            }}
            show={show}
            promotionid={values.promotionid}
            setFieldValue={setFieldValue}
            promotionListsV2={promotionListsV2}
          />
          <label className="mb-2 text-input-label" style={{ color: "white" }}>
            {intl.formatMessage({ id: "amount" })}
          </label>
          <div className="mb-2 position-relative">
            <Field
              name="amount"
              component={Input}
              placeholder={intl.formatMessage({ id: "amount" })}
              autoComplete="off"
              type="number"
              autoFocus={false}
            />
            <div
              className="position-absolute text-prim cursor-pointer"
              style={{ right: "35px", top: "5px", color: "#f5be09" }}
              onClick={() => {
                const [gameBal] = gameBalance.split(".");
                const [mainBal] = mainWallet.split(".");

                setFieldValue(
                  "amount",
                  isDeposit
                    ? mainBal.replaceAll(",", "")
                    : gameBal.replaceAll(",", "")
                );
              }}
            >
              {intl.formatMessage({ id: "all" })}
            </div>
          </div>
          {isDeposit && ResolveArrayNull(promotionListsV2).length > 0 && (
            <div className="mb-2">
              <label className="mb-2 text-input-label">
                {intl.formatMessage({
                  id: getLastSelectedPromo()
                    ? "lastSelectedPromotion"
                    : "promotion",
                })}
              </label>
              {!getLastSelectedPromo() ? (
                values.promotionid === "" &&
                !getSelectedPromo(values.promotionid) ? (
                  <div
                    className="d-flex align-items-center justify-content-center border rounded p-5"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShow(true)}
                  >
                    <div>
                      {intl.formatMessage({ id: "clickToSelectPromo" })}
                    </div>
                  </div>
                ) : (
                  <PromotionItem
                    promo={getSelectedPromo(values.promotionid)}
                    onClick={() => {
                      setShow(true);
                    }}
                  />
                )
              ) : (
                <PromotionItem promo={getLastSelectedPromo()} />
              )}
            </div>
          )}
          <div className="small d-flex justify-content-between align-items-start">
            <div className="small d-flex justify-content-start align-items-center">
              <div className="text-muted me-2">
                {intl.formatMessage({ id: "rate" })} :
              </div>
              <div className="fw-semibold">{rate}</div>
            </div>
            <div>
              <div className="small d-flex justify-content-end align-items-center">
                <div className="text-muted me-2">
                  {intl.formatMessage({ id: "available" })} :
                </div>
                <div className="fw-semibold">
                  {isDeposit ? mainWallet : gameBalance}
                </div>
              </div>
              {isDeposit && (
                <div className="small d-flex justify-content-end align-items-center">
                  <div className="text-muted me-2">
                    {intl.formatMessage({ id: "promoLock" })} :
                  </div>
                  <div
                    className={`fw-semibold ${
                      !CheckIsNull(promoLock) && parseFloat(promoLock) > 0
                        ? "text-danger"
                        : ""
                    }`}
                  >
                    {promoLock}
                  </div>
                </div>
              )}
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};
